import { useDroppable } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Col } from 'antd'

import WishlistItem from './WishlistItem'
import type { WishlistItemWithActions } from './types'

const SortableWishlistItem = (props: WishlistItemWithActions & { disableDragAndDrop?: boolean }) => {
  const { wishlistId, disableDragAndDrop = false } = props

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: wishlistId, disabled: disableDragAndDrop })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
  }

  return (
    <Col
      ref={setNodeRef as React.Ref<HTMLDivElement>}
      style={style}
      xl={8}
      md={12}
      span={24}
    >
      <WishlistItem
        {...props}
        isDragging={isDragging}
        dragHandleProps={disableDragAndDrop ? undefined : Object.assign({}, attributes, listeners) as React.HTMLAttributes<HTMLElement>}
      />
    </Col>
  )
}

export default SortableWishlistItem

/**
 * Used for shared wishlist items: registers as a droppable target so
 * closestCenter can find it (preventing own items from being the collision
 * target when cursor is near shared items), but does not allow reordering.
 */
export const DroppableWishlistItem = (props: WishlistItemWithActions) => {
  const { wishlistId } = props
  const { setNodeRef } = useDroppable({ id: wishlistId })

  return (
    <Col ref={setNodeRef as React.Ref<HTMLDivElement>} xl={8} md={12} span={24}>
      <WishlistItem {...props} isDragging={false} dragHandleProps={undefined} />
    </Col>
  )
}